module.exports = __webpack_public_path__ + "media/images/flags/4x3/moz-4c696fa45c844fe502b72586f57ecc9a.svg";